var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.021,
    height: 45.38,
    viewBox: "0 0 44.021 45.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.035,
    y1: 1,
    x2: 1,
    y2: 0.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_12",
    "data-name": "Union 12",
    d: "M30.367,43.665a9.077,9.077,0,0,1-2.9-1.952q-.077-.077-.151-.155H5.664A5.692,5.692,0,0,1,0,35.85V8.686A5.692,5.692,0,0,1,5.664,2.978h8.6V1.054A1.052,1.052,0,0,1,15.309,0h.447A1.052,1.052,0,0,1,16.8,1.054V2.978h8.363V1.054A1.052,1.052,0,0,1,26.209,0h.447A1.052,1.052,0,0,1,27.7,1.054V2.978h8.191a5.693,5.693,0,0,1,5.664,5.708v21.63a9.113,9.113,0,0,1-11.19,13.349Zm-.535-6.4-.214,1.93a.406.406,0,0,0,.4.45l.045,0,1.928-.213,4.7-4.7-2.162-2.163ZM15.62,38.82h9.9v0a9.1,9.1,0,0,1,1.021-8.9v-.358H15.62Zm-12.9-2.97a2.962,2.962,0,0,0,2.947,2.97h8.076V29.562H2.716Zm33.146-4.615-.955.955,2.162,2.163.955-.955a.812.812,0,0,0,0-1.147L37.01,31.235a.811.811,0,0,0-1.147,0ZM28.42,27.667H28.9a9.1,9.1,0,0,1,9.944-.058v-8.92H28.42Zm-12.8,0H26.54V18.689H15.62Zm-12.9,0H13.739V18.689H2.716Zm0-18.981v8.108H38.84V8.686a2.962,2.962,0,0,0-2.948-2.97H27.7v.618a1.052,1.052,0,0,1-1.045,1.053h-.447a1.052,1.052,0,0,1-1.045-1.053V5.716H16.8v.618a1.052,1.052,0,0,1-1.045,1.053h-.447a1.052,1.052,0,0,1-1.045-1.053V5.716h-8.6A2.962,2.962,0,0,0,2.716,8.686Z",
    transform: "translate(0.5 0.499)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEvent);
export default __webpack_public_path__ + "static/media/editEvent.ffe997250e7ec72ee87465da205c872d.svg";
export { ForwardRef as ReactComponent };